export var constants = {
    ONE_PLAYER: 'onePlayer',
    TWO_PLAYER: 'twoPlayers',
    GRAPHICS: 'graphics',
    STRATEGY: 'strategy',
    RANGE: 'range',
    EV: 'ev',
    EQ: 'eq',
    EQR: 'eqr',
    DIFF_EV: 'diff_ev',
    SUNBURST: 'nextNodesSunburst',
    EQ_GRAPHIC: 'eqLinear',
    EV_GRAPHIC: 'evLinear',
    REPORTS: 'reports',
    MULTI_STACKS: 'combainedMatrix',
    POSITIONS: 'positions',
    STACKS: 'effStacks',
    RAKE: 'rake',
    OPEN_RAISE: 'openRaise',
    ACTIONS: 'actions',
    COMBOS: 'combos',
    DRAWS: 'draws',
    HANDS: 'hands',
    SUNBURST_TYPE: 'sun',
    EQ_GRAPHIC_TYPE: 'eq',
    EV_GRAPHIC_TYPE: 'ev',
    REPORTS_TYPE: 'reports',
    MULTI_STACKS_TYPE: 'multiStack',
    POSITIONS_TYPE: 'positions',
};
export var tabNames = {
    ONE_PLAYER: 'onePlayer',
    TWO_PLAYER: 'twoPlayers',
    GRAPHICS: 'reports',
    STRATEGY: 'strategy',
    RANGE: 'range',
    EV: 'ev',
    EQ: 'eq',
    EQR: 'eqr',
    DIFF_EV: 'diff_ev',
    SUNBURST: 'sunburst',
    EQ_GRAPHIC: 'eqLinear',
    EV_GRAPHIC: 'evLinear',
    REPORTS: 'actions',
    MULTI_STACKS: 'effStacks',
    POSITIONS: 'positions',
};
export var detailTabs = {
    MATRIX: 'matrix',
    ADDED_DATA: 'addedData',
    EV: 'ev',
    FILTERS: 'filters',
    STATS: 'stats',
    DEL_EV: 'delEv',
};
export var detailInfo = {
    NONE: 'none',
    STRATEGY: 'abs',
    EV: 'ev',
    EQ: 'eq',
    EQR: 'eqr',
    RANGE: 'range',
    DIFF_EV: 'diff_ev',
};
export var DETAIL_MATRIX_INFO = {
    ACTIONS: 'actions',
    ACTIONS_WITH_VALUE: 'actions + value',
    VALUE: 'value',
};
export var reportsMapper = {
    nextNodesSunburst: 'reports-sunburst',
    reports: 'reports-actions',
    eqLinear: 'reports-eqLinear',
    evLinear: 'reports-evLinear',
    combainedMatrix: 'reports-effStacks',
    positions: 'reports-positions',
    effStacks: 'reports-effStacks',
    rake: 'reports-rake',
    openRaise: 'reports-openRaise',
    turn: 'reports-turn',
    river: 'reports-river',
    actions: 'reports-actions',
    combos: 'reports-combos',
    draws: 'reports-draws',
    hands: 'reports-hands',
};
